import React, { useState } from 'react';
import { FileCheck, Loader2 } from 'lucide-react';

import toast from 'react-hot-toast';
import { DocumentText1 } from 'iconsax-react';
import type { TMedia } from '@shared/types/media';

interface DownloadButtonProps {
  attachment: TMedia;
}

export const DownloadNoteFileBtn: React.FC<DownloadButtonProps> = ({
  attachment,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const fileUrl = attachment.file || '';

  const handleDownload = async () => {
    setIsDownloading(true);

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileUrl.split('/').pop() || 'file';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
      toast.error(`Download failed, Please try again!`);
    } finally {
      setTimeout(() => {
        setIsDownloading(false);
      }, 300);
    }
  };

  return (
    <div
      className='border border-primary-200 max-w-[180px] p-2 rounded-lg bg-primary-30 flex items-center gap-10 cursor-pointer'
      onClick={handleDownload}
    >
      <div className='flex gap-1 items-center min-w-0 text-gray-800'>
        <FileCheck
          size={16}
          className='shrink-0'
        />
        <span
          className='text-sm truncate'
          title={attachment.name || 'Attachment'}
        >
          {attachment.name || 'Attachment'}
        </span>
      </div>
      {isDownloading ? (
        <Loader2 className='w-4 h-4 animate-spin text-secondary-1000' />
      ) : (
        <DocumentText1
          size={16}
          className='shrink-0'
        />
      )}
    </div>
  );
};
